import { render, staticRenderFns } from "./input-multiple.vue?vue&type=template&id=5b00fbd1&"
import script from "./input-multiple.vue?vue&type=script&lang=js&"
export * from "./input-multiple.vue?vue&type=script&lang=js&"
import style0 from "./input-multiple.vue?vue&type=style&index=0&id=5b00fbd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports